export type ProfileMetrics = {
    followers: number;
    following: number;
    total_likes: number;
    content_count: number;
    total_views: number;
    title: string;
    bio: string;
    image_url: string;
    language: string;
    region: string;
    is_verified: boolean;
    is_private: boolean;
    engagement_rate: number;
    category: string;
};

export type PostMetrics = {
    post_id: string;
    post_url: string;
    media_url: string;
    description: string;
    post_type: string;
    create_time: string;
    parsed_time?: string;
    has_time?: boolean;
    views: number;
    likes: number;
    comments: number;
    shares: number;
    saves: number;
    engagement_rate: number;
};

export type AccountReport = {
    platform: string;
    account_id: string;
    display_name: string;
    profile_url: string;
    period: string;
    profile: ProfileMetrics;
    posts: PostMetrics[] | null;
    error?: string;
};

export type SocialMetricsReport = {
    id: number;
    platform: string;
    account_input: string;
    display_name: string;
    period_label: string;
    created_by: string;
    created_by_uid: string;
    created_at: string;
    snapshot?: AccountReport;
};

export const PLATFORM_LABEL: Record<string, string> = {
    youtube: 'YouTube',
    tiktok: 'TikTok',
    instagram: 'Instagram',
};
